module.exports = __webpack_public_path__ + "img/Angiogenesis-GBM_GSE194329.e17f1db2.png";